<template>
  <div class="machine-info-container">
    <!-- 顶部标题栏 -->
    <div class="header">
      <button @click="$router.go(-1)" class="back-button">返回</button>
      <h2 class="title">机床详情</h2>
    </div>

    <!-- 内容区域 - 可滚动 -->
    <div class="scrollable-content">
      <!-- 状态指示器 -->
      <div class="status-indicator" :class="getStatusClass(workStatus)">
        <span>{{ workStatus }}</span>
      </div>

      <!-- 基本信息卡片 -->
      <div class="info-card">
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">机床</div>
            <div class="info-value">{{ alias }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">刀位号</div>
            <div class="info-value">{{ toolNumber }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">程序名</div>
            <div class="info-value">{{ currentProgram.trim() }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">加工速度</div>
            <div class="info-value">{{ feedSpeed }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">进给</div>
            <div class="info-value">{{ feedOverrides }}%</div>
          </div>
          <div class="info-item">
            <div class="info-label">加工件数</div>
            <div class="info-value">{{ workPieces }}</div>
          </div>
        </div>
      </div>

      <!-- 轴状态卡片 -->
      <div class="axis-card">
        <div class="card-title">轴状态监控</div>

        <div class="axis-list">
          <div v-for="(item, i) in tableList" :key="i" class="axis-item">
            <div class="axis-name">{{ item.name }}</div>

            <div class="progress-container">
              <div class="progress-bar" :style="{ width: getAxisContentPercent(item) + '%' }"></div>
              <div class="progress-text">{{ getAxisContentValue(item) }}</div>
            </div>

            <div class="temperature">
              <span>{{ getTemperature(item) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 温度图表 -->
      <div class="temperature-chart">
        <div class="chart-title">温度趋势</div>
        <div class="chart-placeholder">温度图表区域</div>
      </div>
    </div>
  </div>
</template>

<script>
import {post} from '@/apis/restUtils';

export default {
  data() {
    return {
      detailInfo: null,
      alias: "",
      toolNumber: 0,
      currentProgram: "",
      workPieces: 0,
      workStatus: "加工",
      feedSpeed: 2850,
      feedOverrides: 92,
      tableList: [
        { name: "A", load: 82.6, temperature: 48 },
        { name: "B", load: 16.6, temperature: 44 },
        { name: "X", load: 58.5, temperature: 40 },
        { name: "Y", load: 61.2, temperature: 60 },
        { name: "Z", load: 50.5, temperature: 41 }
      ],
    }
  },
  mounted() {
    this.getNodeInfo();
  },
  methods: {
    getNodeInfo() {
      let id = this.$route.query.id
      let type = this.$route.query.type;

      post("/organization/leafNode/trigger", {key: id, type: type}, response => {
        this.detailInfo = response.data;
        if (this.detailInfo.table != null) {
          this.tableList = this.detailInfo.table;
          this.detailInfo.currentProgram = this.fileNameSiemens(this.detailInfo.currentProgram, '/_N_');
          this.detailInfo.currentProgram = this.fileNameSiemens(this.detailInfo.currentProgram, '/N');
          this.workPieces = this.detailInfo.workPieces;
          this.feedSpeed = this.detailInfo.feedSpeed;
          this.feedOverrides = Math.round(this.detailInfo.feedOverrides);
          this.toolNumber = this.detailInfo.toolNumber;
          this.currentProgram = (this.detailInfo.currentProgram).trim();
          this.workStatus = this.detailInfo.status;
          this.alias = this.detailInfo.alias;
        }
      });
    },

    fileNameSiemens(input, channelPrefix) {
      if (!input) return "";
      let result = input;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const i = result.indexOf(channelPrefix);
        if (i >= 0) {
          result = result.substring(i + channelPrefix.length).trim();
        } else {
          break;
        }
      }
      return result;
    },

    getAxisContentPercent(item) {
      return item && item.load ? item.load : 0;
    },

    getAxisContentValue(item) {
      return this.getAxisContentPercent(item) + "%";
    },

    getTemperature(item) {
      return item.temperature ? item.temperature + "℃" : '';
    },

    getStatusClass(status) {
      switch (status) {
        case '加工': return 'working';
        case '停机': return 'idle';
        case '故障': return 'warning';
        case '未连接': return 'offline';
        default: return '';
      }
    }
  }
}
</script>

<style scoped>
.machine-info-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.back-button {
  padding: 8px 15px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 15px;
  font-size: 14px;
}

.title {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: center;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  -webkit-overflow-scrolling: touch; /* 启用iOS平滑滚动 */
}

.status-indicator {
  padding: 10px 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 1.1rem;
  color: white;
}

.status-indicator.working { background: #52c41a; }
.status-indicator.idle { background: #faad14; }
.status-indicator.warning { background: #f5222d; }
.status-indicator.offline { background: #bfbfbf; }

.info-card, .axis-card, .temperature-chart {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 15px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 6px;
}

.info-label {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 4px;
}

.info-value {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
}

.card-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  padding-bottom: 12px;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.axis-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.axis-item {
  display: flex;
  align-items: center;
}

.axis-name {
  width: 40px;
  font-weight: bold;
  font-size: 1.1rem;
  color: #333;
}

.progress-container {
  flex: 1;
  height: 28px;
  background: #f0f0f0;
  border-radius: 14px;
  position: relative;
  overflow: hidden;
  margin: 0 10px;
}

.progress-bar {
  height: 100%;
  border-radius: 14px;
  background: linear-gradient(90deg, #6ab1ff, #3a8bff);
  transition: width 0.5s ease;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-weight: bold;
  font-size: 0.9rem;
}

.temperature {
  width: 70px;
  text-align: right;
  color: #ff6b6b;
  font-weight: bold;
  font-size: 1rem;
}

.temperature-chart {
  height: 200px;
}

.chart-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.chart-placeholder {
  height: 150px;
  background: #f0f8ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-style: italic;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .axis-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .progress-container {
    margin: 10px 0;
    width: 100%;
  }

  .temperature {
    width: 100%;
    text-align: left;
    padding-left: 40px;
    margin-top: 5px;
  }

  .header {
    padding: 10px;
  }

  .back-button {
    padding: 6px 12px;
    font-size: 13px;
  }

  .title {
    font-size: 1.1rem;
  }
}

/* 触控优化 */
button, .axis-item, .info-item {
  touch-action: manipulation; /* 改善触控响应 */
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}
</style>